import { useState } from "react";
import Swal from "sweetalert2";
import { AdminPublicInfo } from "../../../Api/Admin/models";
import { createUser } from "../../../Api/UserPanel/UserPanel";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { fetchStaticButton } from "../../../Api/Buttons/Buttons";
import { Button } from "../../../Api/Buttons/models";
import { createPlayer } from "../../../Api/Players/Players";
import { approveUserRequest, checkPlayerExists } from "../../../Api/Requests/Requests";

interface Props {
    loading: boolean
    setLoading: (loading: boolean) => void
    form: any
    setForm: (form: any) => void
    adminInfo: AdminPublicInfo | null
    onHide: () => void
    requestId?: string
}
export const useCreatePlayerAndUser = ({ loading, setLoading, form, adminInfo, onHide, requestId }: Props) => {

    const [messagesCreatePlayerAndUser, setMessagesCreatePlayerAndUser] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })


    const handleAproveRequest = async () => {
        if (requestId) {
            await approveUserRequest({ id: requestId })
        }
        onHide()
    }

    const handleCreateUser = async () => {
        const alreadyExists = await checkPlayerExists({ email: form.email, platformUser: form.platformUser })
        if (alreadyExists?.exist) {
            Swal.fire({ icon: 'error', text: alreadyExists?.msg ?? 'Ha ocurrido un error al verificar si el jugador ya existe' })
            return
        }

        if (loading) { return }

        if (form.platformUser.trim().length > 13) {
            toast.error('Debe ingresar un usuario de la plataforma de 13 carácteres o menos')
            return
        }

        // if (!form.email) {
        //     toast.error('Debe ingresar un email')
        //     return
        // }

        // if (!form.phone) {
        //     toast.error('Debe ingresar un teléfono')
        //     return
        // }

        if (!form.password) {
            toast.error('Debe ingresar una contraseña')
            return
        }

        if (form.password.length < 6) {
            toast.error('La contraseña debe tener al menos 6 caracteres')
            return
        }

        setLoading(true)

        const copyMessage = async (text: string) => {
            let updatedMessage = text
                .replaceAll('__USUARIO__', (form.platformUser))
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)
                .replaceAll('__JUGADOR__', `${form.platformUser}`)
                .replaceAll('__EMAIL__', `${form.email ?? form.platformUser ?? ''}`)
                .replaceAll('__GESTORPASSWORD__', `${form.password}`)
                .replaceAll('__GESTORURL__', `${adminInfo?.gestorUrl}`)
            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesCreatePlayerAndUser?.Messages?.length);
        let randomValue = messagesCreatePlayerAndUser?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)

        try {
            const result = await createUser({ name: form.platformUser, password: adminInfo?.default_users_password ?? 'hola123', })
            if (!result.data.includes('ERROR')) {
                toast.success(`Usuario ${form.platformUser} creado`)
                handleCreatePlayer()
            } else {
                const errorMessage = result?.response?.data?.msg ?? result?.data ?? 'Ha habido un error. Reinicia o prueba con otro nombre.'
                Swal.fire({ icon: 'error', text: errorMessage });
                setLoading(false)
            }
        } catch (error: any) {
            let errorMessage = `ERROR: No se ha podido crear, el usuario ${form.platformUser} ya existe, o ha habido un error de conexión.`
            if (error?.response?.data?.msg) {
                errorMessage = error.response.data.msg
            }
            Swal.fire({ icon: 'error', text: errorMessage });
            setLoading(false)
        }
    }



    const handleCreatePlayer = async () => {
        const res = await createPlayer(form)
        if (res?.success) {
            toast.success(`Jugador ${form.platformUser} creado correctamente`)
            toast.success(`Mensaje copiado al portapapeles`)
            handleAproveRequest()
        } else {
            const errorMessage = res?.response?.data?.msg ?? 'Ha habido un error al crear el jugador'
            Swal.fire({ icon: 'error', text: errorMessage })
        }
        setLoading(false)
    };


    useEffect(() => {
        fetchStaticButton('static_newplayerbyemail').then((res) => {
            setMessagesCreatePlayerAndUser(res)
        })
    }, [])

    return { handleCreateUser, handleCreatePlayer, messagesCreatePlayerAndUser, loading }
}
